import style from './shared.module.scss';

export const sharedStyle = {
  gradientBorder: style.gradientBorder,
  shadowBorder: style.shadowBorder,
};
